/*
 * The one place the role names shown in the portal are written down: the Role filter above the user table, the
 * Role column in it, and the Role dropdown in both the Add New User and Edit User dialogs all read from here.
 *
 * The value is what is stored and what every permission check keys on, and it is deliberately left alone by a
 * rename — "creator" is the role in the database, in the JWT and in nexus-api's rolesRanking, and touching it
 * would silently change who may do what. Only the label the operator reads has changed: "Job" → "Job Owners".
 */
export const rolesList = [
    {label: "All", value: 'all'},
    {label: 'Admin/Owner', value: 'owner'},
    {label: 'Job Owners', value: 'creator'},
    // {label: 'Member', value: 'member'},
];